import React from "react";
import { useUser } from "@/backend";
import { useNotificationPush } from "@/backend/notification_push/infrastructura/useNotificationPush";
import {
  Button,
  Card,
  CardBody,
  Divider,
  Tooltip,
} from "@heroui/react";
import { Icon } from "@iconify/react";
import { nanoid } from "nanoid";
import { useRegisterNotification } from "@/hooks/useRegisterNotification";
import { messagePromise } from "@/utils/messagePromise";

function ManagementNotification() {
  const { createNotification, notifications_push } = useNotificationPush();
  const { session, user } = useUser();
  const currentUserAgent = session?.userAgent;
  const createNotify = (token: string) => {
    messagePromise(
      createNotification.mutateAsync({
        token,
        createdAt: new Date(),
        id: nanoid(),
        //@ts-ignore
        userId: user?.id,
        //@ts-ignore
        agent: currentUserAgent,
      }),
      {
        pending: "Agregando a notificaciones",
        success: "Dispositivo agregado correctamente",
        error: "Error al agregar dispositivo",
      }
    );
  };
  const { registerNotifications } = useRegisterNotification(async (token) => {
    await createNotify(token);
  });

  const hasCurrentDevice = notifications_push?.some(
    (notification) => notification.agent === currentUserAgent
  );

  return (
    <div className="w-full mx-auto space-y-6">
      {notifications_push?.map((notification, index) => (
        <Card
          key={index}
          className="border shadow-sm hover:shadow-md transition-shadow"
        >
          <CardBody className="flex items-center space-x-4">
            <Icon
              icon={
                notification.agent === currentUserAgent
                  ? "lucide:smartphone"
                  : "lucide:laptop"
              }
              className="text-2xl text-default-400"
            />
            <div className="flex-grow">
              <p className="text-sm font-medium">
                {notification.agent === currentUserAgent ? (
                  <span className="text-primary flex items-center">
                    Este dispositivo
                    <Tooltip content="Dispositivo actual">
                      <Icon
                        icon="lucide:check-circle"
                        className="ml-1 text-success"
                      />
                    </Tooltip>
                  </span>
                ) : (
                  <span>{notification.agent}</span>
                )}
              </p>
              <p className="text-xs text-default-400">
                {new Date(notification.createdAt).toLocaleString()}
              </p>
            </div>
          </CardBody>
        </Card>
      ))}

      <Divider />

      {!hasCurrentDevice && (
        <div className="flex justify-center">
          <Button
            color="primary"
            onPress={registerNotifications}
            startContent={<Icon icon="lucide:bell-plus" />}
          >
            Dar permiso a este dispositivo
          </Button>
        </div>
      )}
    </div>
  );
}

export default ManagementNotification;
